import store from '@/store';

export default function (eventType) {
  try {
    if (eventType === 'Double.donationCompleted') {
      const donorDetails = store.state?.donation?.donorDetails;

      // Serialize data to remove Vue reactive properties
      const cleanData = JSON.parse(
        JSON.stringify({
          donation: {
            amount: store.getters['donation/totalDonation']?.toFixed(2) || 0,
            currency: store.state?.donation?.currency?.toUpperCase() || 'USD',
            id: store.state?.donation?.donationId || null
          },
          donor: {
            email: donorDetails?.email || null,
            firstName: donorDetails?.firstName || null,
            lastName: donorDetails?.lastName || null,
            phone: donorDetails?.phone || null,
            billingAddress: store.state?.donation?.billingAddress || null
          }
        })
      );

      const event = new CustomEvent('Double.donationCompleted', {
        detail: cleanData
      });

      document.dispatchEvent(event);
    }
  } catch (error) {
    console.error('Error dispatching event:', error);
  }
}
